<div class="sp-row__align">
  <span
    class="sp-margin__right sp-color__primary sp-hidden__before-lg"
    *ngIf="is_seller_email_visible">
    <i>{{ getTruncatedEmail(this.seller_email) }}</i>
  </span>
  <div
    class="sp-row__center"
    [ngClass]="circle_class + ' ' + getCircleSize()">
    <p
      [ngClass]="text_class + ' ' + getTextSize()"
      [matTooltip]="seller_email">
      {{ seller_label | uppercase }}
    </p>
  </div>
  <button
    (click)="onLogoutClick()"
    mat-icon-button
    class="sp-icon__button sp-icon__button-dark sp-margin__left"
    matTooltip="Logout">
    <mat-icon color="primary"> logout </mat-icon>
  </button>
</div>
